import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  width: 100%;
  min-height: 448px;
  padding: 24px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Message = styled.div`
  margin-top: 16px;
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  color: #4d4d4d;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const ErrorTitle = styled.div`
  margin-top: 8px;

  font-family: 'Backpack';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  text-align: center;

  color: #4d4d4d;
`;
